import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { formatDocument, normalizeDocument } from '../../helper/document';
const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  textFieldSize: {
    width: 250,
    marginLeft: '10px',
    marginRight: '15px',
  },
  textFieldManager: {
    marginRight: theme.spacing(1),
    width: 200,
  },
  textFieldSizeManager: {
    width: 250,
    marginRight: '15px',
  },
  textFieldAll: {
    width: '100%',
    marginLeft: '10px',
    marginRight: '15px',
    justifyContent: 'flex-end',
  },
  dense: {
    fontSize: 14,
    marginTop: 19,
    color: '#9C9C9C',
  },
  menu: {
    width: 200,
  },
  span: {
    width: '100%',
    color: '#757575',
  },
  sizeFont: {
    fontSize: 14,
  },
  requiredLabel: {
    transform: 'scaleX(1)',
    color: '#f44336',
  },
  divBankCodeField:{
    width: '70%',
  },
}));

export default function InputAccountBank(props) {
  const classes = useStyles();
  const [contribuinte, setContribuinte] = React.useState("");
  const [values, setValues] = React.useState({
    numeroDAM: '',
    codigoBanco: '',
    nomeBanco: '',
  });

  useEffect(() => {
    if (props.isFindDAMPage !== undefined && props.isFindDAMPage !== null) {
      setValues(oldValues => ({
        ...oldValues,
        numeroDAM: props.isFindDAMPage.DAMValue
      }));
    }
  }, [props.isFindDAMPage])

  useEffect(() => {
      setValues(oldValues => ({
        ...oldValues,
        codigoBanco: props.codigoBancoSelecionado,
      }));
  }, [props.codigoBancoSelecionado])
  
  useEffect(() => {
    setValues(oldValues => ({
      ...oldValues,
      nomeBanco: props.nomeBancoSelecionado,
    }));
}, [props.nomeBancoSelecionado])

useEffect(() => {
  if (props.clearAll) {
    setValues('');
    setContribuinte('');
  }
}, [props.clearAll])

  const handleChange = name => event => {
    let { value } = event.target;

    switch (props.inputType) {
      case 1: {
        props.getBankAgency(value)
        break
      }
      case 2: {
        props.getBankAccount(value)
        break
      }
      case 3: {
        props.getBankDV(value)
        break
      }
      case 4: {
        props.getTypeItem(value)
        break
      }
      case 5: {
        if (isNaN(value)) {
          value = value.replace(/[^0-9]/g, '');
        }

        props.getDAMTyped(event.target.value)
        break
      }
      case 6: {
        const document = normalizeDocument(value);
        setContribuinte(document)
        props.getContribuinteTyped(document)
        break
      }
      case 7: {
        props.getBankTyped(value)
        break
      }
      case 9: {
        const document = normalizeDocument(value);
        setContribuinte(document)
        props.getContribuinteTyped(document)
        break
      }
      default: {
        return null
      }
    }

    setValues(oldValues => ({
      ...oldValues,
      [name]: value,
    }));

  };

  const handleOnlyNumber = event => {
    let theEvent = event || window.event;
    let key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    let value = event.target.value + key;
    let regex = /^\d+(,\d{0,3})?$/;
    let regexDV = /^([A-Za-z0-9]{2})$/;
    let regexNumbersOnly = /^[0-9\b]+$/;

    if (props.inputType === 3) {
      if (!regexDV.test(value)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    } else if (props.inputType === 5) {
      if (!regexNumbersOnly.test(value)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    } else {
      if (!regex.test(value)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  }
  
  
  return (
    <form className={classes.container} noValidate autoComplete="off">

      {props.inputType === 1 &&
        <TextField
          id="agencia"
          label="AGÊNCIA (SEM DV) *"
          className={clsx(classes.textField, classes.dense)}
          onChange={handleChange('agencia')}
          margin="dense"
          onKeyPress={handleOnlyNumber}
          inputProps={{
            maxLength: 10
          }}
        />
      }

      {props.inputType === 2 &&
        <TextField
          id="contaCorrente"
          label="CONTA CORRENTE *"
          className={clsx(classes.textField, classes.dense)}
          onChange={handleChange('contaCorrente')}
          margin="dense"
          onKeyPress={handleOnlyNumber}
          inputProps={{
            maxLength: 8
          }}
        />
      }

      {props.inputType === 3 &&
        <TextField
          id="dv"
          label="DV *"
          className={clsx(classes.textField, classes.dense)}
          onChange={handleChange('dv')}
          margin="dense"
          inputProps={{
            maxLength: 2
          }}
        />
      }

      {props.inputType === 4 &&
        <TextField
          id="contribuinte"
          label="Contribuinte"
          className={clsx(classes.textField, classes.dense)}
          onChange={handleChange('contribuinte')}
          margin="dense"
          inputProps={{
            maxLength: 80
          }}
        />
      }

      {props.inputType === 5 &&
        <TextField
          id="dam"
          label={"NÚMERO DO DAM"}
          className={clsx(classes.textField, classes.textFieldSize)}
          onChange={handleChange('numeroDAM')}
          margin="dense"
          onKeyPress={handleOnlyNumber}
          value={values.numeroDAM}
          inputProps={{
            maxLength: 18
          }}
        />
      }

      {props.inputType === 6 && (
        <div>
          <span className={clsx(classes.span, classes.sizeFont, props.error && classes.requiredLabel)}>CONTRIBUINTE *</span>
          <TextField
            error={props.error}
            autoComplete="on"
            value={formatDocument(contribuinte)}
            id="contribuinte"
            className={clsx(classes.textFieldManager, classes.textFieldSizeManager)}
            // onKeyPress={handleOnlyNumber}
            onChange={handleChange('contribuinte')}
            inputProps={{
              required: props.isFindDAMPage ? false : true,
              maxLength: 18
            }}
          />
        </div>)
      }

      {props.inputType === 7 &&
        <div className={classes.divBankCodeField}>
          <span className={clsx(classes.span, classes.sizeFont, props.error && classes.requiredLabel)}>CÓDIGO DO BANCO</span>
          <TextField
            id="codBank"
            name="codigoBanco"
            value={values.codigoBanco}
            className={clsx(classes.textFieldManager, classes.textFieldSizeManager)}
            onChange={handleChange('codigoBanco')}
            onKeyPress={handleOnlyNumber}
            disabled={props.disabled}
            inputProps={{
              required: true,
              maxLength: 3
            }}
          />
        </div>
      }

      {props.inputType === 8 &&
        <TextField
          id="nameBank"
          label="NOME DO BANCO"
          className={clsx(classes.textField, classes.textFieldAll)}
          value={values.nomeBanco}
          disabled={props.disabled}
          //onChange={handleChange('nameBank')}
          // margin="dense"
          inputProps={{
            required: true,
            maxLength: 20
          }}
        />
      }

      {props.inputType === 9 && (
        <div>
        <span className={clsx(classes.span, classes.sizeFont, props.error && classes.requiredLabel)}>CONTRIBUINTE</span>
        <TextField
          // error={props.error}
          autoComplete="on"
          value={formatDocument(contribuinte)}
          id="contribuinte"
          className={clsx(classes.textFieldManager, classes.textFieldSizeManager)}
          onChange={handleChange('contribuinte')}
          inputProps={{
            required: false,
            maxLength: 18
          }}
        />
      </div>)
      }

    </form>
  );
}
